import { type FC } from 'react';

import { ActivityStatus } from 'connect-graphql/generated';
import { format, isAfter } from 'date-fns';

import Chip from '@mui/material/Chip';

import { getOverdueStatusStyling } from './helpers';

export interface DueDateChipProps {
  readonly dueDate: Date;
  readonly status: ActivityStatus;
}

/**
 * @deprecated
 */
export const DueDateChip: FC<DueDateChipProps> = ({ dueDate, status }) => {
  const displayValue = format(dueDate, 'MMM d');

  const isPastDueDate = isAfter(new Date(), dueDate);
  const isUnsubmitted = status === ActivityStatus.Unsubmitted;

  const { chipColor, chipIcon, chipSx, chipTestid } = getOverdueStatusStyling(
    isPastDueDate,
    isUnsubmitted,
  );

  return (
    <Chip
      color={chipColor}
      data-testid={chipTestid}
      icon={chipIcon}
      label={displayValue}
      size='small'
      sx={chipSx}
      variant='outlined'
    />
  );
};
